import {
  AuditOutlined,
  DollarCircleOutlined,
  FileTextOutlined,
  SendOutlined,
  ShoppingCartOutlined,
  SmileOutlined,
  SyncOutlined,
} from "@ant-design/icons";

export const salesSteps = [
  {
    title: "Sales Lead",
    description: "Capture and qualify new business opportunities seamlessly.",
    icon: SmileOutlined,
    bg: "#e6f7ff",
    color: "#1890ff",
  },
  {
    title: "Sales Quotation",
    description: "Create professional, accurate quotes in minutes.",
    icon: FileTextOutlined,
    bg: "#f6ffed",
    color: "#52c41a",
  },
  {
    title: "Sales Order",
    description: "Convert approved quotations directly into orders.",
    icon: ShoppingCartOutlined,
    bg: "#e6f7ff",
    color: "#1890ff",
  },
  {
    title: "Proforma Invoice",
    description: "Send pre-invoice documents with a single click.",
    icon: SendOutlined,
    bg: "#f9f0ff",
    color: "#722ed1",
  },
  {
    title: "Challan / Delivery Note",
    description: "Track dispatched goods effortlessly.",
    icon: AuditOutlined,
    bg: "#fff7e6",
    color: "#fa8c16",
  },
  {
    title: "Sales Invoice",
    description: "Issue GST-compliant invoices linked to orders.",
    icon: DollarCircleOutlined,
    bg: "#fff1f0",
    color: "#f5222d",
  },
  {
    title: "Credit/Debit Note",
    description: "Handle returns and adjustments easily.",
    icon: SyncOutlined,
    bg: "#f0f0f0",
    color: "#8c8c8c",
  },
];

export enum SalesFeatureText {
  HERO_TITLE = "Sales Management Made Effortless",
  HERO_DESCRIPTION = `Our Complete Sales Journey in One Smart Platform. Welcome to the Sales Management Module of Ease Margin – your ultimate solution to organize, automate, and accelerate your sales operations. From capturing a potential lead to generating final invoices and managing credit or debit notes, we make your sales process seamless, traceable, and incredibly smart.`,
  HERO_BUTTON = "Get Started for Free",

  INTRO_TITLE = "Why Manage Sales the Old Way? Go Smart with Ease Margin.",
  INTRO_DESCRIPTION = `Say goodbye to scattered spreadsheets, missed follow-ups, and disconnected documents. With Ease Margin, every sales step is beautifully connected, fully visible, and easy to control.`,

  SALES_FLOW_TITLE = "🔄 Sales Flow You Can Actually See and Control",
  MULTI_FORMAT_TITLE = "📄 Multi-Format Sales Documents: Flexibility Built In",
  DASHBOARD_TITLE = "📊 Your Sales at a Glance: Dynamic Dashboard",
  ADVANTAGE_TITLE = "⭐ Key Advantages of Ease Margin Sales Management",
  DOC_FORMAT = "📂 Generate Documents in Multiple Formats",
  SHARING_STORE = "📤 Seamless Sharing & Storage",

  PERFECT_FOR_TITLE = "👥 Perfect For:",
  CTA_TITLE = "🚀 Experience Sales Like Never Before.",

  CTA_DESCRIPTION = `Start using Ease Margin’s Smart Sales Management today and watch your sales process transform into a well-oiled, fully connected success engine.`,
  CTA_BUTTON = "Contact Us for a Free Demo",
}

export const salesTemplates = [
  {
    icon: "🧩",
    title: "Customizable Templates",
    description:
      "Add your company logo, terms & conditions, bank details, and more. Choose from pre-built professional templates for each sales document type.",
  },
  {
    icon: "📚",
    title: "Smart Document Repository",
    description:
      "All your sales documents stored in an organized, searchable format. Filter by customer, date, document type, status, and more.",
  },
];

export const salesDashboardFeatures = [
  "Visual sales pipelines",
  "Document status widgets",
  "Pending action alerts",
  "Customer-wise sales summaries",
  "Everything you need to monitor sales — beautifully visualized",
];

export const salesAdvantages = [
  "Streamlined Sales Workflow",
  "Real-Time Visibility & Status Tracking",
  "Multiple Document Format Support",
  "Faster Decision-Making",
  "Zero Errors & GST Compliance",
  "Time-Saving Automation",
  "Professional, Customizable Documents",
];

export const salesTargetAudience = [
  "Trading Companies",
  "Manufacturers",
  "Distributors",
  "SMEs looking to digitize their sales process",
];
